import React from "react";
import { useTranslation } from "react-i18next";
import "../App.css";
import "../utils/styles/PageAnimations.css";

function AboutUsPage() {
  const { t } = useTranslation();

  return (
    <div
      className="about-page page-animated"
      style={{
        padding: "5rem 2rem",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      <h1
        className="animate-up delay-1"
        style={{
          textAlign: "center",
          marginBottom: "4rem",
          fontSize: "3rem",
          color: "#1d2b45",
        }}
      >
        {t("aboutUs.title")}
      </h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: "4rem",
          alignItems: "center",
        }}
      >
        <div
          className="animate-left delay-2"
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src="/images/screens/aboutus.png"
            alt={t("aboutUs.teamImageAlt")}
            className="hover-image"
            style={{
              width: "100%",
              maxWidth: "500px",
              borderRadius: "24px",
              boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
              background: "#fff",
              padding: "1rem",
            }}
          />
        </div>

        <div
          className="animate-right delay-3"
          style={{
            background: "rgba(255,255,255,0.9)",
            borderRadius: "24px",
            padding: "2.5rem",
            boxShadow: "0 10px 30px rgba(31,152,244,0.08)",
            border: "1px solid rgba(3,122,246,0.08)",
          }}
        >
          <h2
            style={{
              marginBottom: "1.5rem",
              fontSize: "2rem",
              color: "#1d2b45",
            }}
          >
            {t("aboutUs.missionTitle")}
          </h2>

          <p
            style={{
              lineHeight: "1.9",
              fontSize: "1.1rem",
              color: "#42526b",
            }}
          >
            {t("aboutUs.missionDescription")}
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutUsPage;
